import React from 'react'

import { Card, CardContent } from '@/components/ui/card'
import { Heading } from '@/components/ui/heading'
import { cn } from '@/lib/utils'

export interface InvalidOrExpiredCardProps {
  title?: React.ReactNode
  content?: React.ReactElement
  className?: string
}

const InvalidOrExpiredCard: React.FC<InvalidOrExpiredCardProps> = ({
  title,
  content,
  className,
}) => (
  <Card className={cn('my-6', className)}>
    <CardContent>
      <Heading as="h1" size={2}>
        {title || 'Invalid link'}
      </Heading>

      {content || (
        <p className="mb-0">This link is either invalid or has been revoked.</p>
      )}
    </CardContent>
  </Card>
)

export default InvalidOrExpiredCard
